import React, { useContext, useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { accountService } from "../../services/accountService";

import Select from "react-select";
import MappingTypeSelect from "./MappingtypeSelect";
import MappingAccountHeadSelect from "./MappingAccountHeadselect";
import { createModal } from "react-modal-promise";
import GeneralModal from "../../helpers/GeneralModal";
import LogicContext from "../../Context/LogicContext";
import DelgroProgressBar from "../../generals/DelgroProgressBar";

export default function MappingAccountPage() {
  // Sample data - replace with your actual data

  const [accountData, setAccountData] = useState({
    transaction_type_info: [],
    mapping_info: [],
    so_shipped: [],
    account_head_info: [],
  });
  const myPromiseModal = createModal(GeneralModal);
  const logicContext = useContext(LogicContext);
  const [transType, setTransType] = useState(0);

  useEffect(() => {
    document.title ="Account mapping"
    if (!accountData?.transaction_type_info?.length) {
      accountService.mapAccountData().then((res) => {
        if (res.data) {
          setAccountData({ ...res.data, mapping_info: [] });
        }
      });
    }
  }, []);


  const onAccountDebitSelect = (selAcc, transaction )=> {
   
    if(transaction?.account_id_credit === selAcc?.account_id){
      return  logicContext.showToast("Cannot add same account as Debit account", "error");
      }
  
      transaction = {...transaction,account_id:selAcc?.account_id }
    
  
    const newList = accountData.mapping_info.map((trans, accIdx)=> {
      if(trans?.code === transaction?.code){
        return transaction;
      } else {
        return trans;
      }
    });
    setAccountData((prev) => {
      return { ...prev, mapping_info: newList };
    });
  };

  const onTransactTypeSelect = async (sel) => {
    const transId = sel?.transaction_type_id;
    setTransType(transId);
     const res =  await accountService.mappedAccountByTransType(transId);
     if(res.data?.mapping_info){
      setAccountData((prev => {
        return  {...prev, mapping_info: res.data?.mapping_info}
      }));
     }else{
      setAccountData((prev => {
        return  {...prev, mapping_info:[]}
      }));
      const msg = res?.data?.result_status[0]?.message_text;
      return logicContext.showToast(msg || "No available data", "info");
    }
  };

  const handleSave = async () => {
    let tempStr = "";
     accountData?.mapping_info?.map((acc) => {
      tempStr +=`<a><code>${acc.code}</code><account_id>${acc?.account_id} </account_id></a>`;
     
    });

    const result =   await myPromiseModal({ title: "Save Record", body: "All record will be saved!",
      showInput: false, placeHolder: ''});
      if(result?.decision === true){
   
      
        accountService.submitMappedAccount({xml_string:`<root>${tempStr}</root>`, transaction_type_id:transType}).then((res)=> {
          const cleanResponse =  logicContext.httpResponseManager(res.data[0]);
          logicContext.showToast(cleanResponse?.message_text, 'success');
        });
    }
  };

  return (
    <div className="bg-gray-50 p-6 rounded-lg shadow-sm">
    {/* Progress Bar */}
    {!accountData?.transaction_type_info?.length && <DelgroProgressBar />}
  
    <div className="mt-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        {/* Mapping Type Select */}
        <div className="w-full sm:max-w-[250px]">
          <MappingTypeSelect
            onTransactTypeSelect={onTransactTypeSelect}
            list={accountData?.transaction_type_info}
            className="text-sm"
          />
        </div>
  
        {/* Title */}
        <h1 className="text-xl sm:text-2xl font-bold text-gray-900 tracking-tight">
          Mapping Account Transactions
        </h1>
      </div>
  
      {/* Divider */}
      <div className="mt-6 h-[1px] w-full bg-gray-200" />
  
      {/* Form Content */}
      <div className="mt-8">
        {/* Table Header */}
        <div className="overflow-x-auto">
          <div className="border border-gray-200 rounded-xl overflow-hidden min-w-[750px]">
            <div className="grid grid-cols-3 bg-gray-100 border-b border-gray-200">
              <div className="px-4 py-3 border-r border-gray-200 text-sm font-semibold text-gray-700">
                ID
              </div>
              <div className="px-4 py-3 border-r border-gray-200 text-sm font-semibold text-gray-700">
                Name
              </div>
              <div className="px-4 py-3 border-r border-gray-200 text-sm font-semibold text-gray-700">
                Account Head
              </div>
            </div>
  
            {/* Form Rows */}
            {accountData?.mapping_info?.map((transaction, index) => (
              <div
                key={index}
                className="grid grid-cols-3 min-h-[60px] border-b border-gray-200 hover:bg-gray-50 transition-colors duration-150"
              >
                {/* ID Field */}
                <div className="px-4 py-3 flex items-center border-r border-gray-200">
                  <span className="text-sm font-medium text-gray-800">
                    {transaction.code}
                  </span>
                </div>
  
                {/* Name Field */}
                <div className="px-4 py-3 flex items-center border-r border-gray-200">
                  <span className="text-sm font-medium text-gray-800">
                    {transaction.name}
                  </span>
                </div>
  
                {/* Account Head Dropdown */}
                <div className="px-4 py-3 border-r border-gray-200">
                  <MappingAccountHeadSelect
                    defaultVal={transaction?.account_name}
                    list={accountData?.account_head_info}
                    onAccountHeadSelect={(data) => onAccountDebitSelect(data, transaction)}
                    className="text-sm"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
  
        {/* Save Button */}
        <div className="mt-4 flex justify-end">
          <button
            onClick={handleSave}
            className="px-6 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
  
  );
}
